/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Stat_TodoInputs */

const en_dashboard_stat_todo = /** @type {(inputs: Dashboard_Stat_TodoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To Do`)
};

const pt_br2_dashboard_stat_todo = /** @type {(inputs: Dashboard_Stat_TodoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Fazer`)
};

/**
* | output |
* | --- |
* | "To Do" |
*
* @param {Dashboard_Stat_TodoInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_stat_todo = /** @type {((inputs?: Dashboard_Stat_TodoInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Stat_TodoInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_stat_todo(inputs)
	return pt_br2_dashboard_stat_todo(inputs)
});